'use client';

import { c as _c } from "react/compiler-runtime";
import SvgFireFill from '@common/icon/SvgFireFill';
import { cn } from '@core/utils';
import { ROLLING_DURATION_MS } from './constants';
import { TrendRankChange } from './TrendRankChange';
import type { TrendKeywordItem } from './useTrendKeywords';
const SIZE_STYLE = {
  mobile: {
    height: 'h-30',
    keywordGap: 'gap-8',
    keyword: 'typo-body4',
    fire: 'size-16'
  },
  desktop: {
    height: 'h-20',
    keywordGap: 'gap-4',
    keyword: 'typo-caption1',
    fire: 'size-14'
  }
} as const;
interface TrendKeywordTrackProps {
  keywords: TrendKeywordItem[];
  step: number;
  size: keyof typeof SIZE_STYLE;
}
export const TrendKeywordTrack = t0 => {
  const $ = _c(20);
  const {
    keywords,
    step,
    size
  } = t0;
  const style = SIZE_STYLE[size];
  let t1;
  if ($[0] !== keywords) {
    t1 = [...keywords, keywords[0]];
    $[0] = keywords;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const rows = t1;
  let t2;
  if ($[2] !== style.height) {
    t2 = cn("block min-w-0 flex-1 overflow-hidden", style.height);
    $[2] = style.height;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = `translateY(-${step * 100 / rows.length}%)`;
  const t4 = step > 0 ? `${ROLLING_DURATION_MS}ms` : "0ms";
  let t5;
  if ($[4] !== t3 || $[5] !== t4) {
    t5 = {
      transform: t3,
      transitionDuration: t4
    };
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== rows || $[8] !== size || $[9] !== style.fire || $[10] !== style.height || $[11] !== style.keyword || $[12] !== style.keywordGap) {
    t6 = rows.map((item, index) => <span key={`${item.ranking}-${index}`} className={cn("flex shrink-0 items-center justify-between gap-8", style.height)}><span className="flex min-w-0 items-center gap-8"><span className="min-w-16 shrink-0 font-500 text-Gray-700 typo-body4">{item.ranking}</span><span className={cn("flex min-w-0 items-center", style.keywordGap)}><span className={cn("truncate font-600 text-Gray-black", style.keyword)}>{item.keyword}</span>{item.spikeYN && <SvgFireFill className={cn("shrink-0 text-O-400", style.fire)} />}</span></span><TrendRankChange rankChange={item.rankChange} isNew={item.newYN} size={size} /></span>);
    $[7] = rows;
    $[8] = size;
    $[9] = style.fire;
    $[10] = style.height;
    $[11] = style.keyword;
    $[12] = style.keywordGap;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t5 || $[15] !== t6) {
    t7 = <span className="flex flex-col transition-transform ease-out motion-reduce:transition-none" style={t5}>{t6}</span>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t2 || $[18] !== t7) {
    t8 = <span aria-hidden={true} className={t2}>{t7}</span>;
    $[17] = t2;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
};